module.exports = true;



//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/core-js/library/modules/_library.js
// module id = 103
// module chunks = 1